<template>
 <div class="sfboxl2">
    <div class="wfull">
        <ul class="hotfbox">
            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="氢氧化镁A7">
                                                <img width="490" height="820" src="../../static/img/A7.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/A7.png 490w, ../../static/img/A7.png 768w, ../../static/img/A7.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化镁A7">氢氧化镁A7</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="氢氧化镁 A7S">
                                                <img width="490" height="820" src="../../static/img/A7S.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/A7S.png 490w, ../../static/img/A7S.png 768w, ../../static/img/A7S.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化镁 A7S">氢氧化镁 A7S</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="氢氧化镁  M17S">
                                                <img width="490" height="820" src="../../static/img/M17S.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/M17S.png 490w, ../../static/img/M17S.png 768w, ../../static/img/M17S.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化镁  M17S">氢氧化镁  M17S</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="无卤阻燃剂 FR516">
                                                <img width="490" height="820" src="../../static/img/FR516.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/FR516.png 490w, ../../static/img/B36.png 768w, ../../static/img/FR516.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="无卤阻燃剂 FR516">无卤阻燃剂 FR516</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="抑烟成碳剂 B36">
                                                <img width="490" height="820" src="../../static/img/B36.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/B36.png 490w, ../../static/img/B36.png 768w, ../../static/img/B36.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="抑烟成碳剂 B36">抑烟成碳剂 B36</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101LC">
                                                <img width="490" height="820" src="../../static/img/101LC002.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101LC002.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC002.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101LC">
                                                <img width="490" height="820" src="../../static/img/101KH003.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101KH003.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101KH003.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101LC">
                                                <img width="490" height="820" src="../../static/img/101KH004.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101KH004.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101KH004.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101LC">
                                                <img width="490" height="820" src="../../static/img/101LC005.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101LC005.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC005.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101LC">
                                                <img width="490" height="820" src="../../static/img/101LC006.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101LC006.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC006.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101LC">
                                                <img width="490" height="820" src="../../static/img/101LC007.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101LC007.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC007.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101LC">
                                                <img width="490" height="820" src="../../static/img/101LC008.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101LC008.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC008.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101LC">
                                                <img width="490" height="820" src="../../static/img/101KH009.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101KH009.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101KH009.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101LC">
                                                <img width="490" height="820" src="../../static/img/101LC010.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101LC010.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC010.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101LC">
                                                <img width="490" height="820" src="../../static/img/101LC011.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101LC011.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC011.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101LC">
                                                <img width="490" height="820" src="../../static/img/101LC012.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101LC012.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC012.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101LC">
                                                <img width="490" height="820" src="../../static/img/101KH013.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101KH013.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101KH013.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101">
                                                <img width="490" height="820" src="../../static/img/101KH014.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101KH014.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101KH014.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101LC">
                                                <img width="490" height="820" src="../../static/img/101LC015.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101LC015.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101LC015.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>

            <li class="sfflli">
                <div class="hotpic">
                    <a href="javascript:void" title="KH-101">
                                                <img width="490" height="820" src="../../static/img/101KH016.png" class="attachment-medium size-medium wp-post-image" alt="landing_2017-02-10t03-41-03-309z" srcset="../../static/img/101KH016.png 490w, ../../static/img/101LC001.png 768w, ../../static/img/101KH016.png 900w" sizes="(max-width: 490px) 100vw, 490px" />                                            </a>
                </div>
                <div class="hottitle">
                    <h2><a href="javascript:void" title="氢氧化铝">氢氧化铝</a></h2>
                    <p></p>
                </div>
                <div class="hotinfo">
                    <div class="xpm Fl"><b class="Fl">关键词：</b></div>
                    <span><a href="javascript:void" rel="tag">阻燃剂</a></span>                
                </div>
            </li>      
            <div class="clear"></div>
        </ul>
    </div>

    <div class="posts-nav wfull"></div>
    <div class="clear"></div>
</div>
</template>

<script>
export default {
  name: 'hello',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App'
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 p{
    text-indent:2em;
  }
</style>



// WEBPACK FOOTER //
// Details.vue?910c2dcc